import Vue from 'vue';

export const set = (state, data) => {
  state.records = data;
};

export const setAgents = (state, data) => {
  console.log("Data",data);
  state.agents = data;
};

export const setStatus = (state, data) => {
  state.status_data = data;
};

export const setBoards = (state, data) => {
  state.boards = data;
};

export const setContact = (state, data) => {
  state.pipelines_contact = data;
};

export const setContacttoItems = (state, contacts) => {
  console.log("Contacts",contacts);
  console.log("Hello",state.records);
    state.records.forEach(list => {
      list.items = []; // Reset the items array for each list
    });
    // state.recods.items=[];
    console.log("Hello",state.records);
    contacts.forEach(contact => {
        
        const targetList = state.records.find(
          list => Number(list.id) === Number(contact.status_id)
        );

        // Log the target list for debugging

        if (targetList) {
            targetList.items.push(contact);
        } else {
            // console.log('List not found for status_id:', contact.status_id)
        }
    });
    console.log("State Records",state.records);
  
};

export const create = (state, data) => {
  state.records.push(data);
};

export const setSingleRecord = (state, data) => {
  const recordIndex = state.records.findIndex(record => record.id === data.id);
  if (recordIndex > -1) {
    state.records[recordIndex] = data;
  } else {
    create(state, data);
  }
};

export const update = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      Vue.set(state.records, index, data);
    }
  });
};

/* when you don't want to overwrite the whole object */
export const updateAttributes = (state, data) => {
  state.records.forEach((element, index) => {
    if (element.id === data.id) {
      Vue.set(state.records, index, { ...state.records[index], ...data });
    }
  });
};

export const updatePresence = (state, data) => {
  state.records.forEach((element, index) => {
    const availabilityStatus = data[element.id];
    Vue.set(
      state.records[index],
      'availability_status',
      availabilityStatus || 'offline'
    );
  });
};

export const updateSingleRecordPresence = (
  records,
  { id, availabilityStatus }
) => {
  const [selectedRecord] = records.filter(record => record.id === Number(id));
  if (selectedRecord) {
    Vue.set(selectedRecord, 'availability_status', availabilityStatus);
  }
};

export const destroy = (state, id) => {
  state.records = state.records.filter(record => record.id !== id);
};

export const updatedrag = (state,{oldIndex,newIndex}) => {
  // console.log("My Data",data);
  console.log("Moving element from position:", oldIndex, "to new position:", newIndex,state);
  if (oldIndex < 0 || oldIndex >= state.records.length || newIndex < 0 || newIndex >= state.records.length) {
    console.error("Invalid indices for moving records.");
    return;
  }

  const [movedElement] = state.records.splice(oldIndex, 1);
  state.records.splice(newIndex, 0, movedElement);
  console.log("State",state.records);
};


/** Distinct contacts currently rendered in a pipeline column (ignores duplicate rows). */
function uniquePipelineColumnContactCount(items) {
  if (!Array.isArray(items)) return 0;
  const ids = items
    .map(item => Number(item?.id))
    .filter(id => Number.isFinite(id));
  return new Set(ids).size;
}

/** Keep first occurrence per contact id (vuedraggable + lazy races can duplicate rows). */
function dedupePipelineColumnItems(targetList) {
  if (!targetList || !Array.isArray(targetList.items) || targetList.items.length < 2) {
    return;
  }
  const seen = new Set();
  const next = [];
  let keptNonNumericIdRow = false;
  for (const item of targetList.items) {
    const id = Number(item?.id);
    if (!Number.isFinite(id)) {
      if (!keptNonNumericIdRow) {
        keptNonNumericIdRow = true;
        next.push(item);
      }
      continue;
    }
    if (seen.has(id)) continue;
    seen.add(id);
    next.push(item);
  }
  if (next.length === targetList.items.length) return;
  Vue.set(targetList, 'items', next);
}

/** After server total_count is applied, remove duplicate contact rows (fixes 42/40). */
function dedupePipelineColumnAfterServerTotal(targetList) {
  if (!targetList || !Array.isArray(targetList.items)) return;
  dedupePipelineColumnItems(targetList);
}

/**
 * When API does not send total_count, never show fewer contacts than distinct
 * cards in the column (avoids (3/2) after out-of-order responses).
 */
function reconcilePipelineListTotalWhenNoServerTotal(targetList) {
  if (!targetList || !Array.isArray(targetList.items)) return;
  const uniqueLoaded = uniquePipelineColumnContactCount(targetList.items);
  const current = Number(targetList.total_count);
  const safeCurrent = Number.isFinite(current) ? current : 0;
  if (uniqueLoaded > safeCurrent) {
    Vue.set(targetList, 'total_count', uniqueLoaded);
  }
}

export const lazyloadingcontacts = (
  state,
  { contacts, page, total_count, status_id }
) => {
  const serverTotal =
    total_count !== undefined && total_count !== null && total_count !== ''
      ? Number(total_count)
      : NaN;
  const hasServerTotal = Number.isFinite(serverTotal);

  if (contacts.length > 0) {
    const touchedListIds = new Set();
    contacts.forEach(contact => {
      const targetList = state.records.find(
        list => Number(list.id) === Number(contact.status_id)
      );

      if (targetList) {
        touchedListIds.add(Number(targetList.id));
        targetList.page = page;
        if (
          (targetList.total_count == null ||
            Number.isNaN(Number(targetList.total_count))) &&
          hasServerTotal
        ) {
          targetList.total_count = serverTotal;
        }
        targetList.contactpresent = true;

        const contactExists = targetList.items.some(
          item => Number(item.id) === Number(contact.id)
        );

        if (!contactExists) {
          targetList.items.push(contact);
        }
      }
    });

    touchedListIds.forEach(id => {
      const list = state.records.find(r => Number(r.id) === id);
      dedupePipelineColumnItems(list);
    });

    // Authoritative: pipelines#index total_count is the true count for the
    // requested status. Applying it after merge prevents optimistic + lazy-load
    // races from inflating per-column totals (and the board sum) until refresh.
    const primarySid =
      status_id === undefined || status_id === null || status_id === ''
        ? NaN
        : Number(status_id);
    if (Number.isFinite(primarySid) && hasServerTotal) {
      const primary = state.records.find(
        list => Number(list.id) === primarySid
      );
      if (primary) {
        Vue.set(primary, 'total_count', serverTotal);
        dedupePipelineColumnAfterServerTotal(primary);
      }
    } else {
      contacts.forEach(contact => {
        const targetList = state.records.find(
          list => Number(list.id) === Number(contact.status_id)
        );
        if (targetList) {
          reconcilePipelineListTotalWhenNoServerTotal(targetList);
        }
      });
    }
  } else if (
    status_id !== undefined &&
    status_id !== null &&
    status_id !== '' &&
    Number.isFinite(Number(status_id))
  ) {
    const sid = Number(status_id);
    const targetList = state.records.find(
      list => Number(list.id) === sid
    );
    if (targetList) {
      targetList.page = page;
      if (hasServerTotal) {
        Vue.set(targetList, 'total_count', serverTotal);
        dedupePipelineColumnAfterServerTotal(targetList);
      } else {
        Vue.set(
          targetList,
          'total_count',
          uniquePipelineColumnContactCount(targetList.items)
        );
        reconcilePipelineListTotalWhenNoServerTotal(targetList);
      }
    }
  }
};

export const setPipelineColumnServerTotal = (state, { status_id, total_count }) => {
  const target = state.records.find(
    list => Number(list.id) === Number(status_id)
  );
  if (!target) return;
  const n = Number(total_count);
  if (!Number.isFinite(n)) return;
  Vue.set(target, 'total_count', Math.max(0, n));
  dedupePipelineColumnAfterServerTotal(target);
};

export const setGraph = (state, data) => {
  state.graphData = data;
};
export const setContactPayment = (state, data) => {
  state.ListContactPayment = data
};
export const setremindercount = (state, count) => {
  state.reminderCount = count;
};
 export const setPastreminder = (state, count)=> {
    state.pastReminderCount = count;
  }